import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerBankForm from '../containers/PlannerBankFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerBankEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerBankEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_bank_route_edit')} />
          <PlannerBankForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerBankEditScreen;

Logger.log('silly', `PlannerBankEditScreen loaded.`);